import Window from '@kaidam/fc-shared/src/frontend/components/dialog/Window'
export default Window